export default [
  {
    info: 'SANDERS, C. et al. Mobilização precoce na UTI: Uma atualização.',
    link: 'http://revistas.unijorge.edu.br/fisioscience/pdf/2012Artigo55_68.pdf.'
  },
  {
    info: 'NUNES, L. L. A.; LIMA, T. de M. Medicamentos utilizados no tratamento da covid-19 em pacientes com perda da capacidade funcional renal: uma revisão rápida da literatura. Jornal Brasileiro de Nefrologia, São Paulo,  dez. 2020 . DOI: http://dx.doi.org/10.1590/2175-8239-jbn-2020-0105.',
    link: 'http://www.scielo.br/scielo.php?script=sci_arttext&pid=S0101-28002020005044202&lng=en&nrm=iso.'
  },
  {
    info: 'PACCIARINI, F. et al. Persistent replication of severe acute respiratory syndrome coronavirus in human tubular kidney cells selects for adaptive mutations in the membrane protein. Journal of Virology, Washington DC, v. 82, n. 11, p. 5137-5144, jun. 2008.'
  },
  {
    info: 'ZOU, X. et al. Single-cell RNA-seq data analysis on the receptor ACE2 expression reveals the potential risk of different human organs vulnerable to 2019-nCoV infection. Frontiers of medicine, [s. l.], v. 14, n. 2, p. 185-192, 2020.'
  },
  {
    info: 'MAO, L. et al. Neurologic manifestations of hospitalized patients with coronavirus disease 2019 in Wuhan, China. JAMA neurology, v. 77, n. 6, p. 683-690, 2020. doi:10.1001/jamaneurol.2020.1127',
    link: 'https://jamanetwork.com/journals/jamaneurology/article-abstract/2764549'
  },
  {
    info: 'BRAZOLOTO, T; FUJARRA, F; SIQUEIRA, J. Disfunção temporomandibular e dor orofacial frente à pandemia de coronavírus: sugestão de conduta. Revista da Associação Paulista de Cirurgiões Dentistas, São Paulo, v. 74, n. 3, p. 229-234, 2020.'
  },
  {
    info: 'CONSELHO REGIONAL DE PSICOLOGIA DA 08 REGIÃO. Manual de psicologia hospitalar. Curitiba: Unificado, 2007.',
    // link: 'Disponível em: https://www.fiocruzbrasilia.fiocruz.br/wpcontent/uploads/2020/04/Sa%c3%bade-Mental-e-Aten%c3%a7%c3%a3o-Psicossocial-na-Pandemia-covid-19-recomenda%c3%a7%c3%b5es-gerais.pd'
  },
  {
    info: 'PELLEGRINI, G; VELEIRO, R. V. B; GOMES, I. C. D. A percepção do gosto salgado em indivíduos com e sem obstrução nasal. Revista CEFAC, São Paulo, v. 7, n. 3, p. 311-317, jul./set. 2005.',
    link: 'https://www.redalyc.org/articulo.oa?id=169320510006.'
  },
  {
    info: 'RIEL, D. V, et al. The olfactory nerve: a shortcut for influenza and other viral diseases into the central nervous system. J Pathol, 2015; 235: 277-287.'
  },
  {
    info: 'TORTORA, G. J, GRABOWSKI, S. R. Corpo Humano: Fundamentos de Anatomia e Fisiologia. 6ª ed. Porto Alegre (RS): Artmed, 2005; 718p.'
  }
]
